<template>

	<svg version="1.0" xmlns="http://www.w3.org/2000/svg"
 width="80.000000pt" height="50.000000pt" viewBox="0 0 80.000000 50.000000"
 preserveAspectRatio="xMidYMid meet">

		<g transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)"
		stroke="none">
		<path d="M0 250 l0 -250 400 0 400 0 0 250 0 250 -400 0 -400 0 0 -250z m610
		190 c0 -18 7 -20 70 -20 l70 0 0 -170 0 -170 -70 0 c-63 0 -70 -2 -70 -20 0
		-19 -7 -20 -210 -20 -203 0 -210 1 -210 20 0 18 -7 20 -70 20 l-70 0 0 170 0
		170 70 0 c63 0 70 2 70 20 0 19 7 20 210 20 203 0 210 -1 210 -20z"/>
		<path d="M427 404 c-14 -14 -7 -34 13 -34 12 0 20 -7 20 -18 0 -14 -7 -17 -40
		-14 -72 7 -116 -46 -90 -109 15 -35 49 -48 127 -48 65 0 88 13 60 34 -12 9
		-17 33 -19 101 l-3 89 -30 3 c-17 2 -34 0 -38 -4z m14 -104 c26 -14 26 -66 0
		-80 -27 -14 -47 -13 -65 6 -45 45 7 104 65 74z"/>
		<path d="M83 328 c-3 -6 1 -16 10 -23 13 -9 17 -29 17 -84 0 -41 -4 -71 -10
		-71 -5 0 -10 -7 -10 -15 0 -12 13 -15 55 -15 42 0 55 3 55 15 0 9 -9 15 -25
		15 -18 0 -25 5 -25 19 0 16 6 18 44 14 38 -5 48 -2 70 20 34 34 34 79 2 112
		-21 21 -33 24 -100 23 -42 0 -79 -5 -83 -10z m148 -28 c26 -14 26 -66 0 -80
		-27 -14 -47 -13 -65 6 -45 45 7 104 65 74z"/>
		<path d="M586 274 c-9 -8 -16 -19 -16 -24 0 -14 18 -21 25 -10 5 7 26 9 60 5
		47 -6 54 -5 64 13 13 25 -3 40 -24 22 -11 -9 -23 -9 -46 -1 -41 14 -45 14 -63
		-5z"/>
		</g>
</svg>
   
</template>

<script>
  export default {
		name: 'PdIcon',
    props: {
      icon: {
        type: String,
        default: '$cancel'
      }
    }
  }
</script>
<style scoped>
svg{
	fill:currentColor;

}
</style>>



